import JSEncrypt from 'jsencrypt';
var mPublicKey = "-----BEGIN PUBLIC KEY-----\nMFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALuCRM5wqGt5Ehhq/pdGHVFZ5kemv5NS\nSaOf6wc0GBJZ4ZBRGsg0SnYsdbb3p3/a9L5IU66b72tWDb89jZur4jUCAwEAAQ==\n-----END PUBLIC KEY-----";
export default {
  encryptRsaPublic: function encryptRsaPublic(string, publicKey) {
    var crypt = new JSEncrypt();
    crypt.setPublicKey(publicKey || mPublicKey);
    var enc = crypt.encrypt(string);
    return enc;
  }
};